<template>
  <div>
    <section id="list-product-lending" class="container">
      <h1 class="product-header">Tabungan Syariah</h1>
      <p class="product-description">
        Dikelola sesuai prinsip syariah, aman, dan penuh keberkahan. Karena menabung tak hanya soal masa depan, tapi juga nilai yang Anda pegang.
      </p>

      <div class="filter-bar">
        <div class="filter-group">
          <label for="lokasi">Lokasi</label>
          <select id="lokasi" v-model="selectedLokasi">
            <option value="Semua">Semua</option>
            <option v-for="(lok, i) in lokasiList" :key="i" :value="lok.value">
              {{ lok.text }}
            </option>
          </select>
        </div>

        <div class="filter-group">
          <label for="urutkan">Urutkan</label>
          <select id="urutkan" v-model="selectedUrutkan">
            <option value="Semua">Semua</option>
            <option v-for="(urut, i) in urutkanList" :key="i" :value="urut.value">
              {{ urut.label }}
            </option>
          </select>
        </div>
        <div class="filter-group search-input-group">
          <label for="search">Cari Produk</label>
          <input
            id="search"
            type="text"
            v-model="searchQuery"
            placeholder="Cari produk"
            class="styled-search"
          />
        </div>
      </div>
      <div class="product-list">
        <div style="display: flex; flex-direction: column; gap: 30px;">
          <template v-if="loading">
            <div
              v-for="n in 6"
              :key="'skeleton-' + n"
              class="skeleton"
            >
              <div class="skeleton-img"></div>
              <div class="skeleton-text"></div>
              <div class="skeleton-text"></div>
              <div class="skeleton-text"></div>
            </div>
          </template>

          <template v-else-if="items.length === 0">
            <div style="text-align: center; width: 100%;">
              <p style="font-weight: 500; color: #555; font-size: 18px;">
                Data belum ada.
              </p>
            </div>
          </template>

          <template v-else>
            <CardProductTabungan
              v-for="(item, index) in items"
              :key="index"
              :data="item"
            />
          </template>
        </div>
      </div>
      <!-- Pagination -->
      <div class="pagination-container">
        <button
          :disabled="pagination.current_page === 1"
          @click="changePage(pagination.current_page - 1)"
        >
          Prev
        </button>

        <button
          v-for="page in totalPages"
          :key="page"
          :class="{ active: page === pagination.current_page }"
          @click="changePage(page)"
        >
          {{ page }}
        </button>

        <button
          :disabled="pagination.current_page === pagination.last_page"
          @click="changePage(pagination.current_page + 1)"
        >
          Next
        </button>
      </div>
    </section>
    <NewFooterClient />
  </div>
</template>

<script>
import NewFooterClient from "@/components/landing-page/newFooterClient.vue";

import TabunganProduct from "../api/tabunganProduct"
import Cookies from "js-cookie";
import CardProductTabungan from "../components/landing-page/cardProductTabungan.vue";

export default {
  components: { NewFooterClient, CardProductTabungan },
  data() {
    return {
      items: [],
      loading: true,
      lokasiList: [],
      jangkaWaktuList: ["6 Bulan", "12 Bulan", "24 Bulan"],
      urutkanList: [
        { label: "Nama Produk - A ke Z", value: "name_asc" },
        { label: "Nama Produk - Z ke A", value: "name_desc" },
        { label: "Bagi Hasil - Tertinggi", value: "nisbah_desc" },
        { label: "Bagi Hasil - Terendah", value: "nisbah_asc" },
        { label: "Setoran Awal - Tertinggi", value: "min_initial_desc" },
        { label: "Setoran Awal - Terendah", value: "min_initial_asc" }
      ],

      selectedLokasi: "Semua",
      selectedJangkaWaktu: "Semua",
      selectedUrutkan: "Semua",
      pagination: {
        current_page: 1,
        last_page: 1,
        total: 0,
      },
      searchQuery: "",
    };
  },
  watch: {
    selectedUrutkan() {
      this.loadData(1);
    },
    selectedLokasi() {
      this.loadData(1);
    },
    selectedJangkaWaktu() {
      this.loadData(1);
    },
    searchQuery() {
      this.loadData(1);
    }
  },
  mounted() {
    this.loadData();
  },
  computed:{
    totalPages() {
      const pages = [];
      for (let i = 1; i <= this.pagination.last_page; i++) {
        pages.push(i);
      }
      return pages;
    },
  },
  methods: {
    async loadData(page = 1) {
      this.loading = true;
      const params = {
        with: "mitra,mitra.mitra_profile,category,subCategory,akad",
        paginate: 10,
        page: page,
      };

      if (this.selectedUrutkan) {
        let orderColumn = "";
        let orderDirection = "";

        switch (this.selectedUrutkan) {
          case "name_asc":
            orderColumn = "nama_produk";
            orderDirection = "asc";
            break;
          case "name_desc":
            orderColumn = "nama_produk";
            orderDirection = "desc";
            break;
          case "nisbah_desc":
            orderColumn = "equal_rate";
            orderDirection = "desc";
            break;
          case "nisbah_asc":
            orderColumn = "equal_rate";
            orderDirection = "asc";
            break;
          case "min_initial_desc":
            orderColumn = "min_initial_deposit";
            orderDirection = "desc";
            break;
          case "min_initial_asc":
            orderColumn = "min_initial_deposit";
            orderDirection = "asc";
            break;
        }

        if (orderColumn && orderDirection) {
          params.order_column = orderColumn;
          params.order_direction = orderDirection;
        }
      }
      if (this.selectedLokasi !== "Semua") {
        params.search_province = this.selectedLokasi;
      }

      if (this.searchQuery.trim() !== "") {
        params.search_query = this.searchQuery.trim();
      }

      const responseProvinsi = await this.$getListWilayah('provinsi');
          const provinsiArray = responseProvinsi.data || [];
          const arrData = provinsiArray.map(item => ({
            value: item.id,
            text: item.name
          }));
      this.lokasiList = arrData;

      TabunganProduct.index(params)
        .then((res) => {
          setTimeout(() => {
            this.items = res.data.data.data;
            this.pagination.current_page = res.data.data.current_page;
            this.pagination.last_page = res.data.data.last_page;
            this.pagination.total = res.data.data.total;
            this.loading = false;
          }, 300);
        })
        .catch((err) => {
          console.log("error produk lending : ", err);
          this.loading = false;
        });
    },
    changePage(page) {
      if (page !== this.pagination.current_page) {
        this.loadData(page);
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    },
    getImageUrl(url) {
      return `${process.env.API_URL}${url}`;
    },
  },
};
</script>

<style>
.pagination-container {
  display: flex;
  justify-content: center;
  gap: 8px;
  margin: 30px 0;
}

.pagination-container button {
  padding: 8px 12px;
  border: 1px solid #ccc;
  background: white;
  cursor: pointer;
  border-radius: 4px;
  min-width: 40px;
}

.pagination-container button.active {
  background-color: #007bff;
  color: white;
  border-color: #007bff;
}

.pagination-container button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.container {
  max-width: 90%;
}
.text-table-orange {
  color: #f7bd3a;
  margin-bottom: 0;
  font-weight: 600;
}
.product-card {
  border: 1px solid #eee;
  border-radius: 12px;
  background-color: #fff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  border: 1px solid #b3b3b3;
}

.filter-bar {
  display: flex;
  gap: 24px;
  margin: 32px 0;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: flex-start;
}

.filter-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 200px;
}

.filter-group label {
  font-weight: 500;
  color: #13346c;
  font-size: 18px;
}

.filter-group select {
  padding: 12px 16px;
  border: 1px solid #ccc;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 500;
  color: #333;
  background-color: #f5f5f5;
  appearance: none;
  background-image: url("data:image/svg+xml;charset=US-ASCII,%3Csvg xmlns='http://www.w3.org/2000/svg' width='292.4' height='292.4'%3E%3Cpath fill='%23000' d='M287 69.4L146.2 210.2 5.4 69.4 0 74.8l146.2 146.2L292.4 74.8z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 16px center;
  background-size: 12px;
}

.filter-group.search-input-group input.styled-search {
  padding: 12px 16px;
  border: 1px solid #ccc;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 500;
  color: #333;
  background-color: #f5f5f5;
  width: 100%;
  box-sizing: border-box;
}

@media (max-width: 768px) {
  
  .filter-bar {
    flex-direction: column;
    gap: 16px;
    align-items: stretch;
  }
}

.table-header {
  padding: 12px;
  background-color: #fff;
  border-radius: 8px;
  border: 1px solid #b3b3b3;
}
.product-image {
  width: 240px;
  height: auto;
}
.table-header-text {
  color: #13346c;
}
.border-left-custom {
  border-left: 1px solid rgba(0, 0, 0, 0.5);
  padding-top: 0;
  padding-bottom: 0;
}
.product-header {
  font-size: 48px;
  font-weight: 800;
  text-transform: capitalize;
  text-align: center;
}
.product-description {
  color: #13346c;
  font-size: 20px;
  text-align: center;
  font-weight: 600;
}
.filter-product {
  margin: 48px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 80px;
}
.filter-card {
  height: 100%;
  background-color: #f9f9f9;
  border: 1px solid #b3b3b3;
  padding: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 16px;
  gap: 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}
.filter-icon {
  width: 100px;
  height: auto;
  margin: auto;
}

@media (max-width: 768px) {
  .product-header {
    font-size: 24px;
    font-weight: 800;
    text-transform: capitalize;
    text-align: center;
  }
  .product-description {
    color: #13346c;
    font-size: 16px;
    text-align: center;
    font-weight: 600;
  }
  .filter-product {
    margin: 48px 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 16px;
  }
  .filter-card {
    height: 100%;
    background-color: #f9f9f9;
    border: 1px solid #b3b3b3;
    padding: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 16px;
    gap: 20px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    width: 100%;
  }
  .filter-icon {
    width: auto;
    height: 100px;
    margin: auto;
  }
}

.skeleton {
  background-color: #ffffff;
  border-radius: 8px;
  padding: 16px;
  position: relative;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  animation: flicker 5s infinite ease-in-out;
}

.skeleton-img {
  width: 100%;
  height: 120px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 400% 100%;
  border-radius: 8px;
  animation: shimmer 5.5s infinite;
}

.skeleton-text {
  height: 16px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 400% 100%;
  border-radius: 4px;
  margin-top: 12px;
  animation: shimmer 5.5s infinite;
}

.skeleton-text:last-child {
  width: 60%;
}

@keyframes shimmer {
  0% {
    background-position: -400% 0;
  }
  100% {
    background-position: 400% 0;
  }
}

@keyframes flicker {
  0% {
    opacity: 0.4;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.4;
  }
}
</style>



// WEBPACK FOOTER //
// src/public/list-produk-tabungan.vue